import { Scale } from "../../utils/Scale"

export class RealPos {

    static slogansX = () => Scale.width() * 0.52
    static slogansY = () => Scale.height() * 0.07

    static doneButtonX = () => Scale.width() * 0.8
    static doneButtonY = () => Scale.height() * 0.85

    static nextButtonX = () => Scale.x(0.86)
    static nextButtonY = () => Scale.y(0.921)

}
